import axios from 'axios';

class Loading {

    constructor() {
        const self = this;
        this.loadingCounter = 0;
        this.allowBlur = true;
        this.loadingContainer = $('body');

        // Apply for every axios's requests
        axios.interceptors.request.use((config) => {
            if (config && config.headers && config.headers.loading) {
                self.loadingContainer = $(config.headers.loading).first();
                delete config.headers.loading;
            } else {
                self.loadingContainer = $('body');
            }

            if (config.headers && (config.headers.allowBlur!=null)){
                this.allowBlur = config.headers.allowBlur;
            }

            if (config.headers && (config.headers.isShowLoadingView || config.headers.isShowLoadingView == null)) {
                self.showLoading(true);
            }
            return config;
        }, (error) => {
            self.showLoading(false);
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            self.showLoading(false);
            return response;
        }, (error) => {
            self.showLoading(false);
            return Promise.reject(error);
        });

        // Apply for every ajax's requests
        $(document).ajaxStart(function () {
            self.showLoading(true);
        }).ajaxStop(function () {
            self.showLoading(false);
        });
    }

    createLoadingView() {
        if (this.loadingContainer.find('.loading-view').length) {
            return;
        }
        const message = Lang.get('common.load_more_message');
        const view = `<div class="loading-view">
            <div class="mask"></div>
            <div class="context loading-icon-context d-flex justify-content-center">
                <img class="loading-icon" src='/img/loading.svg'/>
                <div class="loading-message">
                    ${message}
                </div>
            </div>
        </div>`;

        this.loadingContainer.css({
            position: 'relative',
        }).append(view);
        const loadingView = this.loadingContainer.find('.loading-view');
        loadingView.hide();
    }

    showLoading(status) {
        const self = this;
        self.createLoadingView();
        if (this.allowBlur) {
            $(':focus').blur();
        }
        if (status) {
            self.loadingCounter++;
        } else {
            self.loadingCounter--;
        }
        if (status && !this.loadingContainer.find('.loading-view').is(':visible')) {
            this.loadingContainer.find('.loading-view').show().css({'opacity': 1});
        }
        if (!status && self.loadingCounter <= 0) {
            clearTimeout(self.timeout);
            self.timeout = setTimeout(function () {
                $('.loading-view').animate({
                    opacity: 0,
                }, 100, function () {
                    $('.loading-view').hide();
                });
            }, 1300);
        }

    }
}

export default new Loading();
